module.exports = __webpack_public_path__ + "static/media/fastmail.cefd4bf9.png";